import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("MoneyCompareTerminal", "ExpressionTerminal", {
    defaults: {
      relop: ">",
      value: '0k'
    },

    beforeSet: function(attributes) {
      if (attributes.relop === '==') {
        attributes = _.extend({}, attributes, { relop: '=' });
      }

      return attributes;
    },

    type: function() {
      return 'MoneyCompare';
    },

    text: function() {
      return (
        [
          this.get('terminal'),
          this.get('relop'),
          this.get('value')
        ].join(" ")
      );
    }
  });
});
